/*  export const MENU_API="https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.6089845&lng=77.29420809999999&restaurantId="; */
export const MENU_API="https://api.abhisheksuman.me/restaurant"; 

export const IMG_CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
export const IMG_MENU_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_254,h_160,c_fill/";

export const IMG_OFFER_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_600,c_fill/";
export const BEST_OFFER_URL = "https://api.abhisheksuman.me/restaurant";

